
import util from "../../util";
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import BScroll from "better-scroll";
import Cookies from "js-cookie";
export default {
components: {
XInput,
Group,
XButton
},
data() {
return {
account: "",
accountTip: "请输入读者证号",
password: "",
btnText: "",
bscroll: "",
isWXClient: util.isWXClient() && Cookies.get("code"),
bindType: this.$route.query.type 
};
},
mounted() {
this.initScroll();
this.initTitle();
if (this.bindType == "2") {
this.getUserAccount();
}
if (Cookies.get("token") === "myyh") {
this.accountTip = "请输入读者证号/身份证号码";
} else if (Cookies.get("token") === "sgsjsxy") {
this.accountTip = "请输入学生学号";
} else {
this.accountTip = "请输入读者证号";
}
},
computed: {
isDisabled() {
if (this.bindType == "2") {
return !this.account.length;
} else {
return !(this.account.length && this.password.length);
}
}
},
methods: {
showErrMsg() {
this.$vux.toast.text("必填");
},
initTitle() {
let titObj = {
1: this.isWXClient ? "证件绑定" : "用户登录",
2: this.isWXClient ? "证件解绑" : "退出登录",
3: "证件挂失"
};
let btnObj = {
1: this.isWXClient ? "绑定" : "登录",
2: this.isWXClient ? "解绑" : "退出登录",
3: "确定"
};
this.btnText = btnObj[this.bindType];
document.title = titObj[this.bindType];
},
initScroll() {
let wrapper = document.querySelector(".p-card_bind");
if (!this.bscroll) {
this.bscroll = new BScroll(wrapper, {
click: true,
bounce: {
top: false,
bottom: false,
left: false,
right: false
}
});
} else {
this.bscroll.refresh();
}
},
getUserAccount() {
this.account = Cookies.get("dzzhao");
},
handleConfirm() {
if (this.bindType == "1") {
this.hadleBindCard();
} else if (this.bindType == "2") {
this.hadleUnBindCard();
} else if (this.bindType == "3") {
this.hadleLossCard();
} else {
this.hadleBindCard();
}
},
hadleBindCard() {
this.$vux.loading.show();
this.$http("post", "/user/binding", {
dzzhao: this.account,
password: this.password
})
.then(res => {
this.$vux.loading.hide();
Cookies.set("openId", res.data.uid, 30);
Cookies.set("username", res.data.username, 30);
Cookies.set("dzzhao", res.data.dzzhao, 30);
util.saveLocalStorage(Cookies.get("token"), {
openId: res.data.uid,
username: res.data.username,
dzzhao: res.data.dzzhao
});
this.$vux.toast.show({
text: this.isWXClient ? "绑定读者证成功" : "登录成功"
});
this.$router.go(-1);



})
.catch(() => {
this.$vux.loading.hide();
});
},
hadleUnBindCard() {
this.$vux.loading.show();
this.$http("post", "/user/unBinding")
.then(() => {
this.$vux.loading.hide();
Cookies.remove("openId");
Cookies.remove("username");
Cookies.remove("dzzhao");
util.removeLocalStorage(Cookies.get("token"));
this.$vux.toast.show({
text: this.isWXClient ? "证件解绑成功" : "退出登录成功"
});
this.$router.push({
name: "Home"
});
})
.catch(() => {
this.$vux.loading.hide();
});
},
hadleLossCard() {
this.$vux.loading.show();
this.$http("post", "/user/cardLost", {
dzzhao: this.account,
password: this.password
})
.then(() => {
this.$vux.loading.hide();
this.$vux.toast.show({
text: "证件挂失成功"
});
})
.catch(() => {
this.$vux.loading.hide();
});
}
}
};
